import { merge } from "lodash";

import { clientStateVar } from "./reactiveVars";

export default ({ data, feature }) => {
  let state = data;
  if (feature) {
    state = {
      [feature]: data
    };
  }

  clientStateVar(merge({}, clientStateVar(), state));
};
